// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-module--root--T2KyK","logo":"footer-module--logo--1ZAKZ"};